import { DateTime } from 'luxon'

// This applies to the v7 pre sale.
export const preSaleStart = DateTime.fromISO(localStorage.preSaleStart ? localStorage.preSaleStart : FONTAWESOME.V7_PRE_SALE_START_DATE, { zone: 'utc' })
export const preSaleEnd = DateTime.fromISO(localStorage.preSaleEnd ? localStorage.preSaleEnd : FONTAWESOME.V7_PRE_SALE_END_DATE, { zone: 'utc' })
export const livestreamEnd = DateTime.fromISO(localStorage.livestreamEnd ? localStorage.livestreamEnd : FONTAWESOME.V7_LIVESTREAM_END_DATE, { zone: 'utc' })

export function timeToPreSale() {
  return getTimeRemainingObject(preSaleStart)
}

export function timeToPreSaleEnd() {
  return getTimeRemainingObject(preSaleEnd)
}

export function getTimeRemainingObject(endTime) {
  const diff = endTime.diffNow(['days', 'hours', 'minutes']).values

  const timeRemaining = {
    days: diff.days,
    hours: diff.hours,
    minutes: Math.ceil(diff.minutes)
  }

  return timeRemaining
}